// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"502":"dec4c112","1144":"3db5fcb7","3230":"31e902f1","6914":"3db5fcb7","7400":"f7ca2ca4","8693":"f7ca2ca4"}[chunkId] + ".chunk.css";
};